import { Navigate as RouterNavigate } from 'react-router-dom';
import type { NavigateProps } from 'react-router-dom';

import { useMergeRoutes } from '@core/hooks/create-path.hook.ts';
import { Routes } from '@core/constants/routes';
import { MergeRoutesConfig } from '@core/lib/merge-routes';

interface AppNavigateProps extends Omit<NavigateProps, 'to'> {
  to: Routes | Routes[];
  config?: MergeRoutesConfig;
}

export function Navigate({ to, config = {} }: AppNavigateProps) {
  const path = useMergeRoutes(to, config);
  return <RouterNavigate to={path} />;
}
